import * as actionTypes from "./actionTypes";
import { firebase } from "../../firebase/index";
import { collections } from "../../firebase/firestoreNameSpaces";
import { removeSpecificFromArray, sortArrayObjects } from "../utility";

export const onAddToWishlist = (userId, productId) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      if (!userId) {
        alert("Please Login");
        return reject("Please Login");
      }
      try {
        dispatch({
          type: actionTypes.ADD_TO_WHISLIST,
          payload: { addBtnLoading: true },
        });
        let db = firebase.firestore();
        await db
          .collection(collections.USERS)
          .doc(userId)
          .set({ wishlist: { [productId]: true } }, { merge: true });
        let wishlist = getState().account.wishlist;
        wishlist.push(productId);
        let user = getState().auth.user;
        if (user.wishlist) {
          user.wishlist = { ...user.wishlist, [productId]: true };
        } else {
          user["wishlist"] = { [productId]: true };
        }

        // console.log(wishlist)
        dispatch({
          type: actionTypes.ADD_TO_WHISLIST,
          payload: { addBtnLoading: false, wishlist: wishlist },
        });
        resolve(wishlist);
      } catch (error) {
        dispatch({
          type: actionTypes.ADD_TO_WHISLIST,
          payload: { addBtnLoading: false },
        });
        reject(error);
        alert(error.message);
      }
    });
  };
};

export const onRemoveFromWishlist = (userId, productId) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch({
          type: actionTypes.REMOVE_FROM_WHISLIST,
          payload: { addBtnLoading: true },
        });
        let db = firebase.firestore();
        await db
          .collection(collections.USERS)
          .doc(userId)
          .set(
            {
              wishlist: { [productId]: firebase.firestore.FieldValue.delete() },
            },
            { merge: true }
          );
        let wishlist = getState().account.wishlist;
        wishlist = removeSpecificFromArray(wishlist, productId);

        let wishlistproducts = getState().account.wishlistproducts;
        wishlistproducts = wishlistproducts.filter((pr) => pr.id != productId);

        dispatch({
          type: actionTypes.REMOVE_FROM_WHISLIST,
          payload: {
            addBtnLoading: false,
            wishlist: wishlist,
            wishlistproducts,
          },
        });

        resolve(wishlist);
      } catch (error) {
        dispatch({
          type: actionTypes.REMOVE_FROM_WHISLIST,
          payload: { addBtnLoading: false },
        });
        reject(error);
        return alert(error.message);
      }
    });
  };
};

export const onFecthWishlist = (userId) => {
  return async (dispatch, getState) => {
    try {
      if (!userId) {
        return false;
      }
      // console.log("Fetching Wishlist")
      let user = getState().auth.user;
      let accountWishlist = getState().account.wishlist;
      let wishlist = [];
      if (!user) {
        alert("Wishlist");
        dispatch({
          type: actionTypes.FETCH_WHISLIST,
          payload: { loading: true },
        });
        let db = firebase.firestore();
        let data = (
          await db.collection(collections.USERS).doc(userId).get()
        ).data();
        wishlist = Object.keys(data.wishlist);
        dispatch({
          type: actionTypes.FETCH_WHISLIST,
          payload: { loading: false },
        });
      } else {
        if (accountWishlist.length) {
          wishlist = accountWishlist;
        } else {
          if (user.wishlist) {
            wishlist = Object.keys(user.wishlist);
          }
        }
      }

      if (wishlist) {
        dispatch({
          type: actionTypes.FETCH_WHISLIST,
          payload: { wishlist: wishlist },
        });
      }
    } catch (error) {
      console.log(error);
      dispatch({
        type: actionTypes.FETCH_WHISLIST,
        payload: { loading: false, wishlist: [] },
      });
      return alert(error.message);
    }
  };
};

export const onGetWishlistProducts = (userId) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: actionTypes.FETCH_WHISLIST,
        payload: { loading: true },
      });
      let db = firebase.firestore();
      let data = (
        await db.collection(collections.USERS).doc(userId).get()
      ).data();

      if (data && data.wishlist) {
        let wishlist = Object.keys(data.wishlist).sort();
        if (!wishlist.length) {
          return dispatch({
            type: actionTypes.FETCH_WHISLIST,
            payload: { loading: false },
          });
        }

        let limit = getState().account.limitwishlist;
        let snapshot = await db
          .collection(collections.PRODUCTS)
          .where("id", "in", wishlist)
          .limit(limit)
          .get();

        if (snapshot.size) {
          let wishlistproducts = [];
          snapshot.forEach((doc) => {
            wishlistproducts.push(doc.data());
          });

          let lastDocwishlist = snapshot.docs[snapshot.size - 1];

          dispatch({
            type: actionTypes.FETCH_WHISLIST,
            payload: {
              loading: false,
              lastDocwishlist: lastDocwishlist,
              wishlistproducts: wishlistproducts,
              wishlist: wishlist,
              leadsexhaustedwishlist: snapshot.size < limit ? true : false,
            },
          });
        } else {
          dispatch({
            type: actionTypes.FETCH_WHISLIST,
            payload: {
              leadsexhaustedwishlist: snapshot.size < limit ? true : false,
              loading: false,
              wishlist: wishlist,
            },
          });
        }
      } else {
        dispatch({
          type: actionTypes.FETCH_WHISLIST,
          payload: { loading: false },
        });
      }
    } catch (error) {
      dispatch({
        type: actionTypes.FETCH_WHISLIST,
        payload: { loading: false },
      });
      return alert(error);
    }
  };
};
export const onLoadMoreWishlist = (
  leadsexhaustedwishlist,
  lastDocwishlist,
  limit
) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: actionTypes.FETCH_WHISLIST,
        payload: { loadMoreWhislist: true },
      });
      let wishlistproducts = getState().account.wishlistproducts;
      let wishlist = getState().account.wishlist;
      let lastDocId = lastDocwishlist.data().id;

      let ldindex = wishlist.findIndex((w) => w == lastDocId);
      if (ldindex > -1) {
        wishlist = wishlist.splice(ldindex + 1, limit);
        if (!wishlist.length) {
          return dispatch({
            type: actionTypes.FETCH_WHISLIST,
            payload: { loadMoreWhislist: false, leadsexhaustedwishlist: true },
          });
        }
      } else {
        return dispatch({
          type: actionTypes.FETCH_WHISLIST,
          payload: { loadMoreWhislist: false, leadsexhaustedwishlist: true },
        });
      }

      let db = firebase.firestore();
      let snapshot = await db
        .collection(collections.PRODUCTS)
        .where("id", "in", wishlist)
        .limit(limit)
        .get();

      snapshot.forEach((doc) => {
        wishlistproducts.push(doc.data());
      });

      lastDocwishlist = snapshot.docs[snapshot.size - 1];

      if (snapshot.size) {
        if (snapshot.size < limit) {
          dispatch({
            type: actionTypes.FETCH_WHISLIST,
            payload: {
              loadMoreWhislist: false,
              wishlistproducts: wishlistproducts,
              lastDocwishlist: lastDocwishlist,
              leadsexhausted: true,
            },
          });
        } else {
          dispatch({
            type: actionTypes.FETCH_WHISLIST,
            payload: {
              loadMoreWhislist: false,
              wishlistproducts: wishlistproducts,
              leadsexhaustedwishlist: leadsexhaustedwishlist,
            },
          });
        }
      } else {
        dispatch({
          type: actionTypes.FETCH_WHISLIST,
          payload: {
            loadMoreWhislist: false,
            leadsexhaustedwishlist: true,
          },
        });
      }
    } catch (error) {
      dispatch({
        type: actionTypes.FETCH_WHISLIST,
        payload: { loadMoreWhislist: false },
      });
      return alert(error);
    }
  };
};
export const contactUs = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.ACCOUNT_CONTROLS,
        payload: { loading: true },
      });
      let response = await firebase.functions().httpsCallable("contactUs")(
        data
      );

      dispatch({
        type: actionTypes.ACCOUNT_CONTROLS,
        payload: { loading: false },
      });
      return alert("We willl get in touch with you in 48 hours");
    } catch (error) {
      dispatch({
        type: actionTypes.ACCOUNT_CONTROLS,
        payload: { loading: false },
      });
      return alert(error);
    }
  };
};
